import { Dropdown, Spinner } from "react-bootstrap";

import More from "assets/images/svg/more.svg";
import { useTranslation } from "react-i18next";

export interface PanelItem {
  label: string;
  action: () => void;
}

interface Props {
  actions: PanelItem[];
  isLoading?: boolean;
}

export default function ActionsPanelComponent({
  actions = [],
  isLoading = false,
}: Props) {
  const { t } = useTranslation();
  return (
    <div>
      <Dropdown>
        <Dropdown.Toggle variant="success" id="dropdown-basic">
          {isLoading ? (
            <Spinner variant="danger" animation="border" size="sm" />
          ) : (
            <img src={More} alt="more" />
          )}
        </Dropdown.Toggle>

        <Dropdown.Menu>
          {actions.map((action: PanelItem) => {
            if (!action) return null;
            return (
              <Dropdown.Item
                key={action.label}
                onClick={action.action ? action.action : () => undefined}
              >
                {t(action.label) as string}
              </Dropdown.Item>
            );
          })}
        </Dropdown.Menu>
      </Dropdown>
    </div>
  );
}
